import { FEATURE_FLAGS, useFlag } from './feature-flags';

/**
 * Whether the caller's agency gets the paged workspace document: the pages view, comments and
 * Send to Cara, and the editor that edits the stored HTML. Off serves main's editor from
 * pages/copilot/workspace/legacy-editor.
 */
export const usePagedDocumentsEnabled = (): boolean => useFlag(FEATURE_FLAGS.AGENCY_BRAND_DESIGN);
